<template lang="pug">

  .background
    .login-box
      img.login-box__img(
        src="../../../../static/images/logo-pontotel.svg"
      )

      hr

      slot
        component(:is="type", :forgotPasswordData="forgotPasswordData")

      hr

      .rights-reserved
        | © {{ new Date().getFullYear() }} PontoTel. Todos os direitos reservados

      .versao
        | {{ versao }}

</template>

<script>
import Login from './Login'
import ForgotPassword from './ForgotPassword'
import ApplyForgotPassword from './ApplyForgotPassword'
import {versaoGitFiltrada} from 'src/utils'

export default {
  props: {
    type: { required: true, type: String },
    forgotPasswordData: { required: false, type: Object, 'default': null }
  },
  data () {
    return {
      error: '',
      versao: ''
    }
  },
  created () {
    this.versao = versaoGitFiltrada(process?.env?.VUE_APP_TAG_VERSION)
  },
  components: { Login, ForgotPassword, ApplyForgotPassword }
}
</script>

<style scoped>
.background {
  background-image: url(https://s3-sa-east-1.amazonaws.com/lar21css/background_1.jpeg);
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  position: fixed;
  top: 0;
  right: 0;
}

.background, .background img {
  width: 100% !important;
  height: 100% !important;
  margin: 0 auto;
  top: 0;
}

.login-box {
  background: white;
  position: absolute;
  top: 10%;
  left: 68%;
  padding: 20px;
}

.versao {
  text-align: center;
  font-size: small;
  font-weight: bold;
}

</style>
